export default __webpack_public_path__ + "static/media/right-arrow-angle.d0720d2f.svg";